










































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { CalendarIcon, CheckIcon, XIcon } from 'vue-feather-icons';

export type DueFilterValue = 'all' | 'today' | 'week';

@Component({
  name: 'TaskDueDateFilter',
  components: {
    CalendarIcon,
    CheckIcon,
    XIcon,
  },
})
export default class TaskDueDateFilter extends Vue {
  @Prop({ type: String, default: 'all' })
  dueFilter!: DueFilterValue;

  hovered = false;

  dueOptions: { value: DueFilterValue; label: string }[] = [
    { value: 'all', label: 'Alle Fälligkeiten' },
    { value: 'today', label: 'Heute fällig' },
    { value: 'week', label: 'Diese Woche fällig' },
  ];

  get displayLabel(): string {
    const opt = this.dueOptions.find((o) => o.value === this.dueFilter);
    return opt?.label ?? 'Alle Fälligkeiten';
  }

  selectDueFilter(value: DueFilterValue) {
    this.$emit('update:dueFilter', value);
  }

  clearFilter() {
    this.$emit('update:dueFilter', 'all');
  }
}
